export const timeHours = [
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12'
];

export const timeMinutes = ['00', '15', '30', '45'];
export const timeAMPM = ['AM', 'PM'];
